import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MasterDataDTO } from 'src/app/models/MasterDataDTO.model';
import { MasterdataRequestDTO } from 'src/app/models/MasterdataRequestDTO.model';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Alert } from 'src/app/shared/models/Alert';
import { UserRequestDTO } from 'src/app/shared/models/UserRequestDto';
import { AlertService } from 'src/app/shared/services/alert.service';
import { emailValidator } from 'src/app/validators/email.validator';
import { CommonModule } from '@angular/common';
import { FormatPhoneUsDirective } from '../../../directives/format-phone-us.directive';
import { FormatEmailDirective } from '../../../directives/format-email.directive';
import { ValidatePermissionsService } from '../../../shared/services/validate-permissions.service';

@Component({
    selector: 'app-update-distributor',
    templateUrl: './update-distributor.component.html',
    styleUrls: ['./update-distributor.component.css'],
    imports: [CommonModule, FormsModule, ReactiveFormsModule, FormatPhoneUsDirective, FormatEmailDirective]
})
export class UpdateDistributorComponent {
  form = new FormGroup({
    email: new FormControl('', [Validators.required, emailValidator()])
  });

  get emailModel() { return this.form.get('email'); }

  validMail: boolean = false;
  @Input() distributorDataInput: UserDTO = {} as UserDTO;

  information: string = 'Distributor ID/Account: ';
  customerName: string = '';
  address: string = '';
  city: string = '';
  zipCode?: number = undefined;
  stateSelected: string = '';
  states: MasterDataDTO[] = [];
  contactNumber?: string = undefined;
  email?: string = '';
  fieldsCompleted: boolean = false;

  masterdataRequestDTO: MasterdataRequestDTO = { idMaster: 1 };

  customer: UserDTO = {
    userAddressLine1: '',
    userAddressLine2: '',
    userCity: '',
    userMail: '',
    userExpirationPass: new Date('2020-05-05'),
    userNames: '',
    userPassword: '',
    userPhone: undefined,
    userPostalCode: undefined,
    userRegister: new Date('2020-05-05'),
    userState: '',
    userId: undefined,
    userStatus: undefined,
    numberPlans: undefined,
    numberDevices: undefined,
    listUserRole: [],
    listUserPlanDev: []
  };

  UserRequestDTO: UserRequestDTO = { userId: undefined };
  alert: Alert = {} as Alert;


  public permissionsService = inject(ValidatePermissionsService);
  private router = inject(Router);
  private customerService = inject(CustomerService);
  private alertService = inject(AlertService);

  ngOnInit() {
    this.information = this.information + this.distributorDataInput.userId;
    this.UserRequestDTO.userId = this.distributorDataInput.userId;

    this.customerService.getCustomerById(this.UserRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null ? this.handleGetUserByIdSuccess(Data) : this.handleSaveError(StatusCode),
      () => { this.errorMessage(); this.clearFields(); }
    );

    this.customerService.getMastersById(this.masterdataRequestDTO).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null ? this.handleGetAllStatesSuccess(Data) : this.handleSaveError(StatusCode),
      () => { this.errorMessage(); this.clearFields(); }
    );
  }

  clearFields() {
    this.address = '';
    this.contactNumber = undefined;
    this.customerName = '';
    this.email = '';
    this.stateSelected = '';
    this.zipCode = undefined;
    this.city = '';
  }

  goBack() { this.router.navigate(['/distributors']); }

  updateCustomer() {
    this.customer.userAddressLine1 = this.address;
    this.customer.userPhone = this.contactNumber;
    this.customer.userNames = this.customerName;
    this.customer.userMail = this.email;
    this.customer.userState = this.stateSelected;
    this.customer.userPostalCode = this.zipCode;
    this.customer.userCity = this.city;
    this.customer.listUserRole = [];
    this.customer.listUserPlanDev = [];

    this.customerService.updateCustomer(this.customer).subscribe(
      ({ StatusCode, Message, Data }) =>
        Data != null ? this.handleSaveSuccess(Data) : this.handleSaveError(StatusCode),
      () => { this.errorMessage(); this.clearFields(); }
    );
  }

  checkFields() {
    this.fieldsCompleted = !!(this.customerName && this.contactNumber && this.email);
  }

  checkEmailValidity() {
    this.validMail = !!this.emailModel?.valid;
  }

  handleSaveError(StatusCode: number) { this.errorMessage(); this.clearFields(); }

  async handleSaveSuccess(result: boolean) {
    this.alert = { alertMessage: 'Distributor updated successfully', alertType: 'alert alert-success', alertCenter: false, alerTitle: '', duration: 3000 };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(this.alert);
    this.clearFields();
    location.reload();
  }

  handleGetAllStatesSuccess(states: MasterDataDTO[]) { this.states = states; }

  handleGetUserByIdSuccess(customer: UserDTO) {
    this.customer = customer;
    this.customerName = customer.userNames;
    this.address = customer.userAddressLine1;
    this.zipCode = customer.userPostalCode;
    this.stateSelected = customer.userState;
    this.contactNumber = customer.userPhone;
    this.email = customer.userMail;
    this.city = customer.userCity;
    this.checkFields();
  }

  errorMessage() {
    this.alert = { alertMessage: 'Unexpected error. Please try again later.', alertType: 'alert alert-danger', alertCenter: false, alerTitle: '', duration: 3000 };
    this.alertService.updateAlertState(this.alert);
  }
}
